module.exports = __webpack_public_path__ + "media/images/doc-thumb-5aa96fb4a2a5c8bde92240663c502807.png";